import { Component } from '@angular/core';

import { useDispatcher } from '../../../../../store.decorator';
import { EventCentreDialogService } from '../../event-centre-dialog.service';
import { selectCategory } from '../../state/select-category.action';

@Component({
    selector: 'cmps-event-centre-tab-bar',
    templateUrl: './tab-bar.component.html',
    host: {
        class: 'cmps-event-centre-tab-bar',
    },
})
export class TabBarComponent {
    constructor(/** @private */ readonly _service: EventCentreDialogService) {}

    /** @private */
    _onCategoryClick(categoryId: string): void {
        useDispatcher(this._service, selectCategory({ categoryId }));
    }
}
